import { jsx as _jsx } from "react/jsx-runtime";
import { Eye, EyeClosed } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { memo, useCallback } from "react";
import { useIsFlattenedView } from "~/hooks/search/useIsFlattenedView";
export const MobileToggleNestedItemsButton = /*#__PURE__*/ memo(()=>{
    const { setIsFlattenedView, isFlattenedView } = useIsFlattenedView();
    const onClick = useCallback(()=>{
        setIsFlattenedView(!isFlattenedView);
    }, [
        isFlattenedView,
        setIsFlattenedView
    ]);
    const label = isFlattenedView ? "Collapse nested items" : "Expand nested items";
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: label,
        children: /*#__PURE__*/ _jsx(IconButton, {
            appearance: "ghost",
            color: isFlattenedView ? "blue" : "grey",
            "data-testid": "MOBILE_TOGGLE_NESTED_ITEMS_BUTTON",
            icon: isFlattenedView ? EyeClosed : Eye,
            label: label,
            onClick: onClick,
            size: "medium"
        })
    });
});
MobileToggleNestedItemsButton.displayName = "MobileToggleNestedItemsButton";
